import React from 'react';
import Lottie from 'react-lottie';
import animationData from '~/lotties/onboarding/loading-bicycle_white.json';
import cx from 'classnames';

export interface OverlayLoadingProps {
  className?: string;
}

export function OverlayLoading({ className }: OverlayLoadingProps) {
  return (
    <div
      className={cx(className, [
        'absolute v2-animate-fade-in-150 v2-bg-black/50 w-full h-full z-[9999]',
        'rounded-2xl flex items-center justify-center top-0 left-0 rounded-none',
      ])}
    >
      <Lottie
        options={{
          animationData: animationData,
          ...{
            loop: true,
            autoplay: true,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          },
        }}
        width={150}
        height={150}
      />
    </div>
  );
}
